const State = {
    applyStateClass(state, root, regex) {
    // check if the html element contains the root (e.g. 'attractState') of the
    // class we want to apply (e.g. 'attractState_true')
        const el = document.querySelector(`html[class*="${root}"]`)
        if (el) {
            // if so, remove only the specific class (e.g. 'attractState_true'), not any other classes
            el.classList.remove(el.className.match(regex))
        }
        // then, add the new state class to the html element
        if (state != null) {
            document.getElementsByTagName("html")[0].classList.add(state)
        }
    },
    setMainNavState(state) {
        if (this.mainNavState === state) {
            return
        }
        this.mainNavState = state
        this.applyStateClass(state, "main_nav", /\bmain_nav_\S+/g)
    },
    getMainNavState() {
        return this.mainNavState
    },
    setMainNavSticky(state) {
        if (this.mainNavSticky === state) {
            return
        }
        this.mainNavSticky = state
        this.applyStateClass(state, "primary_nav_sticky", /\bprimary_nav_sticky_\S+/g)
    },
    getMainNavSticky() {
        return this.mainNavSticky
    },
    setQuickshopState(state) {
        if (this.quickshopState === state) return
        this.quickshopState = state
        this.applyStateClass(state, "quickshop", /\bfilter_modal_\S+/g)
    },
    getQuickshopState() {
        return this.quickshopState
    },
    setFilterModalState(state) {
        if (this.filterModalState === state) return
        this.filterModalState = state
        this.applyStateClass(state, "filter_modal", /\bfilter_modal_\S+/g)
    },
    getFilterModalState() {
        return this.filterModalState
    },
    setFilterSticky(state) {
        if (this.filterSticky === state) {
            return
        }
        this.filterSticky = state
        this.applyStateClass(state, "filter_sticky", /\bfilter_sticky_\S+/g)
    },
    getFilterSticky() {
        return this.filterSticky
    },
    setMobileFilterState(state) {
        if (this.mobileFilterState === state) {
            return
        }
        this.mobileFilterState = state
        this.applyStateClass(state, "mobile_filters", /\bmobile_filters_\S+/g)
    },
    getMobileFilterState() {
        return this.mobileFilterState
    },
    setSearchNavState(state) {
        if (this.searchNavState === state) {
            return
        }
        this.searchNavState = state
        this.applyStateClass(state, "search_nav", /\bsearch_nav_\S+/g)
    },
    getSearchNavState() {
        return this.searchNavState
    },
    setBasketNavState(state) {
        if (this.cartNavState === state) {
            return
        }
        this.cartNavState = state
        this.applyStateClass(state, "basket_quickview", /\bbasket_quickview_\S+/g)
    },
    getBasketNavState() {
        return this.cartNavState
    },
    setModalState(state) {
        if (this.modalState === state) {
            return
        }
        this.modalState = state
        this.applyStateClass(state, "modal", /\bmodal_\S+/g)
    },
    getModalState() {
        return this.modalState
    },
    getLoginNavState() {
        return this.loginNavState
    },
    setLoginNavState(state) {
        if (this.loginNavState === state) {
            return
        }
        this.loginNavState = state
        this.applyStateClass(state, "login_nav", /\blogin_nav_\S+/g)
    },
}

export default State
